export default "__VITE_ASSET__CCE1dgo___"